import type { FieldDef } from "./RecordEditDialog";

export const invoiceFields: FieldDef[] = [
  { name: "number", label: "Fakturanummer", kind: "text" },
  {
    name: "status",
    label: "Status",
    kind: "select",
    options: [
      { value: "draft", label: "Utkast" },
      { value: "open", label: "Öppen" },
      { value: "paid", label: "Betald" },
      { value: "void", label: "Makulerad" },
      { value: "uncollectible", label: "Avskriven" },
    ],
  },
  { name: "amount_cents", label: "Belopp (öre)", kind: "number", help: "10 000 öre = 100 kr" },
  { name: "currency", label: "Valuta", kind: "text" },
  { name: "due_date", label: "Förfallodatum", kind: "date" },
  { name: "sent_at", label: "Skickad", kind: "datetime" },
  { name: "paid_at", label: "Betald", kind: "datetime" },
  { name: "manually_marked_paid", label: "Manuellt betald", kind: "boolean" },
  { name: "ocr_reference", label: "OCR-referens", kind: "text" },
  { name: "reminder_count", label: "Antal påminnelser", kind: "number" },
  { name: "order_id", label: "Kopplad beställning (id)", kind: "text" },
  { name: "subscription_id", label: "Kopplat abonnemang (id)", kind: "text" },
  { name: "notes", label: "Anteckning", kind: "textarea", full: true },
];

export const invoiceCreateFields: FieldDef[] = [
  { name: "user_id", label: "Kund (id)", kind: "text", help: "Kundens id från kundlistan" },
  ...invoiceFields,
];

export const orderFields: FieldDef[] = [
  { name: "product_name", label: "Paket", kind: "text" },
  { name: "quantity", label: "Antal tuber", kind: "number" },
  {
    name: "status",
    label: "Status",
    kind: "select",
    options: [
      { value: "pending", label: "Väntande" },
      { value: "shipped", label: "Skickad" },
      { value: "cancelled", label: "Avbruten" },
    ],
  },
  {
    name: "order_mode",
    label: "Typ",
    kind: "select",
    options: [
      { value: "subscription", label: "Prenumeration" },
      { value: "purchase", label: "Engångsköp" },
    ],
  },
  {
    name: "payment_method",
    label: "Betalsätt",
    kind: "select",
    options: [
      { value: "invoice", label: "Faktura" },
      { value: "card", label: "Kort" },
    ],
  },
  {
    name: "payment_status",
    label: "Betalstatus",
    kind: "select",
    options: [
      { value: "scheduled", label: "Planerad" },
      { value: "awaiting_payment", label: "Väntar betalning" },
      { value: "paid", label: "Betald" },
      { value: "failed", label: "Misslyckad" },
      { value: "refunded", label: "Återbetald" },
      { value: "partially_refunded", label: "Delvis återbetald" },
      { value: "cancelled", label: "Avbruten" },
    ],
  },
  { name: "subtotal_cents", label: "Delsumma (öre)", kind: "number" },
  { name: "total_cents", label: "Totalt (öre)", kind: "number" },
  { name: "currency", label: "Valuta", kind: "text" },
  { name: "created_at", label: "Skapad", kind: "datetime" },
  { name: "subscription_id", label: "Kopplat abonnemang (id)", kind: "text" },
  {
    name: "shipping_address",
    label: "Leveransadress (JSON)",
    kind: "json",
    full: true,
    help: 'Exempel: {"name":"Företag","address":"Gatan 1","postalCode":"11122","city":"Stockholm","country":"SE"}',
  },
  {
    name: "items",
    label: "Innehåll (JSON)",
    kind: "json",
    full: true,
    help: 'Exempel: [{"product_id":"immune","name":"Immune","quantity":4}]',
  },
];

export const orderCreateFields: FieldDef[] = [
  { name: "user_id", label: "Kund (id)", kind: "text" },
  ...orderFields,
];

export const subscriptionFields: FieldDef[] = [
  { name: "nickname", label: "Smeknamn", kind: "text" },
  {
    name: "status",
    label: "Status",
    kind: "select",
    options: [
      { value: "active", label: "Aktiv" },
      { value: "paused", label: "Pausad" },
      { value: "cancelled", label: "Uppsagd" },
    ],
  },
  { name: "tier_tubes", label: "Antal tuber", kind: "number" },
  { name: "monthly_price_cents", label: "Månadspris (öre)", kind: "number" },
  { name: "currency", label: "Valuta", kind: "text" },
  { name: "next_delivery_date", label: "Nästa leverans", kind: "date" },
  { name: "paused_until", label: "Pausad till", kind: "date" },
  { name: "cancelled_at", label: "Uppsagd", kind: "datetime" },
  { name: "current_period_end", label: "Periodslut", kind: "datetime" },
  {
    name: "payment_method_type",
    label: "Betalsätt",
    kind: "select",
    options: [
      { value: "invoice", label: "Faktura" },
      { value: "card", label: "Kort" },
    ],
  },
  { name: "is_pilot", label: "Pilotkund", kind: "boolean" },
  { name: "created_at", label: "Startdatum", kind: "datetime" },
  {
    name: "quantities",
    label: "Fördelning per produkt (JSON)",
    kind: "json",
    full: true,
    help: 'Exempel: {"immune":4,"energy":4}',
  },
  { name: "shipping_address", label: "Leveransadress (JSON)", kind: "json", full: true },
];

export const subscriptionCreateFields: FieldDef[] = [
  { name: "user_id", label: "Kund (id)", kind: "text" },
  ...subscriptionFields,
];

export const profileFields: FieldDef[] = [
  { name: "first_name", label: "Förnamn", kind: "text" },
  { name: "last_name", label: "Efternamn", kind: "text" },
  { name: "company", label: "Företag", kind: "text" },
  { name: "email", label: "E-post", kind: "text" },
  { name: "phone", label: "Telefon", kind: "text" },
  { name: "vitamin_stations", label: "Antal vitaminstationer", kind: "number" },
  {
    name: "status",
    label: "Kontostatus",
    kind: "select",
    options: [
      { value: "pending", label: "Väntar godkännande" },
      { value: "approved", label: "Godkänd" },
      { value: "rejected", label: "Nekad" },
    ],
  },
];

export const billingFields: FieldDef[] = [
  { name: "company_name", label: "Företagsnamn", kind: "text" },
  { name: "org_number", label: "Organisationsnummer", kind: "text" },
  { name: "vat_number", label: "Momsnummer", kind: "text" },
  { name: "contact_name", label: "Kontaktperson", kind: "text" },
  { name: "email", label: "Fakturamejl", kind: "text" },
  { name: "reference", label: "Er referens", kind: "text" },
  { name: "address", label: "Adress", kind: "text", full: true },
  { name: "postal_code", label: "Postnummer", kind: "text" },
  { name: "city", label: "Ort", kind: "text" },
  { name: "country", label: "Land", kind: "text" },
];

export const billingCreateFields: FieldDef[] = [
  { name: "user_id", label: "Kund (id)", kind: "text" },
  ...billingFields,
];
